import { render, staticRenderFns } from "./WebsiteGeneralForm.vue?vue&type=template&id=1f217a52&scoped=true&"
import script from "./WebsiteGeneralForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteGeneralForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f217a52",
  null
  
)

export default component.exports